$(document).ready(function(){ 
  $('[data-add-to-cart]').click(function (e) { 
    e.preventDefault();
      setTimeout(function() {  
    $('.cart_preview').css('background','#0000002e');
    $('.cart_preview').css('opacity','1');                 
    $('.cart_preview').css('visibility','visible');
    $(".cart_preview_inner").css('transform','translateX(0)');     
   }, 650); 
   });
  $(".add-js").click(function() {
   $('.cart_preview').css('background','#0000002e');
    $('.cart_preview').css('opacity','1');                 
    $('.cart_preview').css('visibility','visible');
    $(".cart_preview_inner").css('transform','translateX(0)');         
  });
  
  $(".close_cart").click(function() {
    $('.cart_preview').css('background','transparent');
    $('.cart_preview').css('opacity','0');
    $('.cart_preview').css('visibility','hidden');
    $(".cart_preview_inner").css('transform','translateX(100%)');  
  });  
  
  $("#close_cart").click(function() {
    $('.cart_preview').css('opacity','0');
    $('.cart_preview').css('visibility','hidden');
    $(".cart_preview_inner").css('transform','translateX(100%)');  
  });  
 
  $(".cart-open").click(function() {  
    if ($(window).width() > 960) {  
      $('.cart_preview').css('background','#0000002e');
      $('.cart_preview').css('opacity','1');
      $('.cart_preview').css('visibility','visible');
      $(".cart_preview_inner").css('transform','translateX(0)');
    }
    else {
     $('.cart_preview').css('background','#0000002e');
     $('.cart_preview').css('opacity','1');
     $('.cart_preview').css('visibility','visible');
     $(".cart_preview_inner").css('transform','translateX(0)');
    }
  }); 
  
  $('.open__cart').click(function() { 
    $('.cart_preview').css('background','#0000002e');
    $('.cart_preview').css('opacity','1');
    $('.cart_preview').css('visibility','visible');
    $(".cart_preview_inner").css('transform','translateX(0)');
  });
  
  const $menu = $('.cart_preview_inner'); 
  $(document).mouseup(e => {
    if (!$menu.is(e.target) // if the target of the click isn't the container...
    && $menu.has(e.target).length === 0) // ... nor a descendant of the container
    {
     $('.cart_preview').css('opacity','0');
     $('.cart_preview').css('visibility','hidden');
     $(".cart_preview_inner").css('transform','translateX(100%)'); 
    }
  });

   $(document).on('cart.requestStarted', function (event, cart) {
    $('.cart__submit').prop('disabled', true).val('LOADING ..');
  });
  
  $(document).on('cart.requestComplete', function (event, cart) {
    var cartCount = cart.item_count
      var counts = document.querySelectorAll("[data-cart-count]");
      if (cartCount !== null) {
        counts.forEach((count) => {
        count.setAttribute('data-cart-count', cartCount);
        
        count.innerHTML = cartCount < 11 ? `${cartCount}` : '9+';
      });
    }
    
    setTimeout(() => {
      $('.cart__submit').prop('disabled', false).val('CHECKOUT');
    }, 1000)
  });

// GEO IP

   $.ajax({
		url: "https://geolocation-db.com/jsonp",
		jsonpCallback: "callback",
		dataType: "jsonp",
		success: function( location ) {
         var locations = ["Australia","Fiji","Hong Kong","India","Indonesia","Japan","Macau","Malaysia","New Zealand","Philippines","Thailand","Singapore","South Korea","Vietnam"];
         console.log(location.country_name);
         if ($.inArray(location.country_name, locations) !== -1) {
            console.log('Australasia');
         }
          else{
            if (document.cookie.split(';').some((item) => item.includes('GOLD=A'))){ 
             
           } else {
           console.log('Rest of world');  
          
           $('.location-popup').addClass('location-open');
           if(location.country_name == 'United Arab Emirates') {
               $('.location-popup--inner h2').text('عذراً، في الوقت الحالي خدمة الشحن والتوصيل إلى دولة الإمارات العربية المتحدة عبر هذا الموقع غير متوفرة.');
               $('.location-popup--inner p').html('يمكنكم طلب عطور جولدفيلد آند بانكس على موقع بليثورا عبر الرابط التالي: <a href="https://plethora.ae/brand/goldfield-banks/"><img class="plethora" src="https://cdn.shopify.com/s/files/1/0376/8972/0972/files/Picture_1.png?v=1638764449"></a><br><br>If you wish to continue to use this store, please select "Continue Shopping International" or select one of our other stores below.');
               $('.location-popup--inner .location__eu').text('SHOP EUROPE (€)');
               $('.location-popup--inner .location__us').text('SHOP USA / Canada ($USD)');
               $('.location-popup--inner .location__au').text("CONTINUE SHOPPING INTERNATIONAL ($AUD)");
           }
           else if(location.country_name == 'Italy') {
               $('.location-popup--inner h2').text('Siamo spiacenti, non spediamo in italia da questo negozio.');
               $('.location-popup--inner p').html('Puoi trovare Goldfield & Banks Australia sul sito ufficiale del nostro rivenditore italiano : <a href="https://www.finmark.it/brand/goldfield-banks/">www.finmark.it/brand/goldfield-banks/</a><br><br>Se desideri continuare a navigare questo negozio, seleziona "continua lo shopping in europa" o seleziona uno degli altri nostri negozi qui sotto:');
               $('.location-popup--inner .location__eu').text('Shop Europa (€)');
               $('.location-popup--inner .location__us').text('Shop USA / Canada ($USD)');
               $('.location-popup--inner .location__au').text('Continua lo shopping in Internazionale ($AUD)');
           }  
           else {
               $('.location-popup--inner h2').text("Sorry, we don't ship to your location from this store.");
               $('.location-popup--inner p').text("If you wish to continue to use this store, please select 'Continue Shopping Europe' or select one of our other stores below.");
               $('.location-popup--inner .location__eu').text('SHOP EUROPE (€)');
               $('.location-popup--inner .location__us').text('SHOP US / CANADA ($USD)');
               $('.location-popup--inner .location__au').text('CONTINUE SHOPPING INTERNATIONAL ($AUD)');
           }  
          }
        }
        }
	});
     
    // LOCATION POPUP + COOKIE SET
     
    $(document).ready(function() {
      
    
   

      $('.location__us').click(function() {
        document.cookie = "GOLD=U";
      });
      
      $('.location__eu').click(function() {
        document.cookie = "GOLD=E";
      });
      
      $('.location__au').click(function() {
        document.cookie = "GOLD=A";
        $('.location-popup').removeClass('location-open');
      });
      
    });



});

 


